import React, { useState } from 'react';
import { BusinessOutlined, Cancel, Description, DescriptionOutlined, HelpOutline, MailOutline, Person, PersonOutline, PhoneOutlined, Send, SubjectOutlined } from "@mui/icons-material";
import { Box, Button, Container, Grid, Icon, IconButton, TextField } from "@mui/material";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import UserHeader from '../../layouts/UserHeader';
import { instance } from '../../utils/api';

const cl = "app-page-userform";
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
function UserForm() {
    const [topic, setTopic] = useState('');

    const handleChange = (event) => {
        setTopic(event.target.value);
    };


    const [full_name, setfull_name] = useState('');
    const [company, setCompany] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [help_topic, setHelpTopic] = useState("");
    const [subject, setSubject] = useState('');
    const [description, setDescription] = useState('');
    const [attachement, setAttachement] = useState([]);

    const handleFileUpload = (event) => {
        const files = event.target.files;

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            setAttachement((prevFiles) => [...prevFiles, file]);
        }
    };


    const handleRemoveFile = (index) => {
        setAttachement((prevFiles) => prevFiles.filter((file, i) => i !== index));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('full_name', full_name);
        formData.append('company', company);
        formData.append('email', email);
        formData.append('phone', phone);
        formData.append('help_topic', help_topic);
        formData.append('subject', subject);
        formData.append('description', description);

        attachement.forEach((file, index) => {
            formData.append('attachment', file);
        });
        

        try {
            const response = await instance.post('tickets/create/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.status === 200 || response.status === 201) {
                console.log('Ticket submitted successfully');
    
                alert('Ticket submitted successfully');
    
                
                setfull_name('');
                setCompany('');
                setEmail('');
                setPhone('');
                setHelpTopic('');
                setSubject('');
                setDescription('');
                setAttachement([]);
            } else {
                console.error('Failed to submit the ticket');
            }
        } catch (error) {
            console.error('Network error:', error);
        }
    };


    return (
        <>
            <UserHeader />
            <div className={cl}>
                <div className={`${cl}__strip`}>
                    <div className={`${cl}__striptext`}>
                        <h1>Submit a Ticket</h1>
                    </div>
                </div>
                <div className={`${cl}__wrapper`}>
                    <div className={`${cl}__card`}>
                        <div className={`${cl}__cardbody`}>
                            <Grid container spacing={4}>
                                <Grid item sm={12} md={6} lg={6} xl={6}>
                                    <div className="userform__field">
                                        <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                            <PersonOutline sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                            <TextField fullWidth required id="input-with-sx" value={full_name}
                                                onChange={(e) => setfull_name(e.target.value)} label="Full Name" placeholder="Enter fullname" variant="standard" />
                                        </Box>
                                    </div>
                                </Grid>
                                <Grid item sm={12} md={6} lg={6} xl={6}>
                                    <div className="userform__field">
                                        <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                            <BusinessOutlined sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                            <TextField fullWidth required value={company}
                                                onChange={(e) => setCompany(e.target.value)} id="input-with-sx" label="Company" placeholder="Enter company" variant="standard" />
                                        </Box>
                                    </div>
                                </Grid>
                                <Grid item sm={12} md={6} lg={6} xl={6}>
                                    <div className="userform__field">
                                        <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                            <MailOutline sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                            <TextField fullWidth required value={email}
                                                onChange={(e) => setEmail(e.target.value)} id="input-with-sx" label="Email" placeholder="Enter your email" variant="standard" />
                                        </Box>
                                    </div>
                                </Grid>
                                <Grid item sm={12} md={6} lg={6} xl={6}>
                                    <div className="userform__field">
                                        <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                            <PhoneOutlined sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                            <TextField fullWidth id="input-with-sx" value={phone}
                                                onChange={(e) => setPhone(e.target.value)} label="Phone Number" placeholder="Enter your phone number" variant="standard" />
                                        </Box>
                                    </div>
                                </Grid>
                                <Grid item sm={12}>
                                    <div className="userform__field">
                                        <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                            <HelpOutline sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                            <FormControl variant="standard" fullWidth>
                                                <InputLabel id="demo-simple-select-label">Help Topic</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={help_topic}
                                                    onChange={(e) => setHelpTopic(e.target.value)}
                                                    label="Help Topic"
                                                    placeholder='Select helpticket'
                                                >
                                                    <MenuItem value={1}>Support</MenuItem>
                                                    <MenuItem value={2}>Maintainance</MenuItem>
                                                    <MenuItem value={3}>Payments</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </div>
                                </Grid>
                                <Grid item sm={12}>
                                    <div className="userform__field">
                                        <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                            <SubjectOutlined sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                            <TextField fullWidth required id="input-with-sx" label="Subject" value={subject}
                                                onChange={(e) => setSubject(e.target.value)} placeholder="Enter summary of issue" variant="standard" />
                                        </Box>
                                    </div>
                                </Grid>
                                <Grid item sm={12}>
                                    <div className="userform__field">
                                        <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                            <DescriptionOutlined sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                            <TextField fullWidth multiline id="input-with-sx" value={description} onChange={(e) => setDescription(e.target.value)} label="Description" placeholder="Enter description of issue" variant="standard" />
                                        </Box>
                                    </div>
                                </Grid>
                                <Grid item sm={12}>
                                    <div className="userform__field">
                                        <span className="userform__field--label">Attachments</span>
                                        <div className='upload-files-box'>
                                            <ul className='upload-files-list'>
                                                {attachement.map((file, index) => (
                                                    <li key={index} className='upload-files-listitem'>
                                                        <Description className='uploadfile-icon' />
                                                        <span className='uploadfile-title'>{file.name}</span>
                                                        <IconButton size='small' onClick={() => handleRemoveFile(index)}>
                                                            <Cancel />
                                                        </IconButton>
                                                    </li>
                                                ))}
                                                <li className='upload-files-listbutton'>
                                                    <Button component="label" variant="contained">
                                                        <CloudUploadIcon className='uploadfile-icon' />
                                                        <span className='uploadfile-title'>Upload file</span>
                                                        <input
                                                            type="file"
                                                            style={{ display: 'none' }}
                                                            onChange={handleFileUpload}
                                                            multiple
                                                        />
                                                        <VisuallyHiddenInput type="file" />
                                                    </Button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item sm={12}>
                                    <div className="userform__field--button">
                                        <Button color='primary' type='submit' variant='contained'
                                            onClick={handleSubmit}
                                        ><Send /> Submit</Button>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default UserForm;
